import { SelectData } from "../../models";
import { ProjectPhase } from "../project-phase";

export class TemplateStepConstants {
  public static readonly ADD_OPERATION = "Add";

  public static readonly REMOVE_OPERATION = "Remove";

  public static readonly PHASE_SELECT_DATA = [
    { key: ProjectPhase.feasibility, value: ProjectPhase.feasibility },
    { key: ProjectPhase.design, value: ProjectPhase.design },
    { key: ProjectPhase.implementation, value: ProjectPhase.implementation },
    { key: ProjectPhase.ongoingMonitoring, value: "Ongoing monitoring" },
  ] as SelectData;

  public static readonly REPEATABLE_RADIO_BUTTON_DATA = [
    { key: true, value: "Yes" },
    { key: false, value: "No" },
  ];

  public static readonly DEFAULT_ADD_TEMPLATE_STEP = {
    defaultStepName: null,
    defaultPhase: null,
    defaultIsRepeatable: null,
  };

  public static readonly DEFAULT_ADD_STEP = {
    stepName: null,
    phase: null,
    isRepeatable: null,
  };
}
